// src/pages/Profile.js
import React, { useState } from 'react';
import useAuthStore from '../store/authStore';
import provinces from '../data/provinces.json';
import cities from '../data/cities.json';

const Profile = () => {
  const { user, logout } = useAuthStore();
  const [isEditing, setIsEditing] = useState(false);
  const [editedUser, setEditedUser] = useState({ ...user });
  const [filteredCities, setFilteredCities] = useState([]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === 'province_id') {
      const selectedProvinceId = Number(value);
      const provinceCities = cities.filter(c => c.province_id === selectedProvinceId);
      setFilteredCities(provinceCities);
      setEditedUser({ ...editedUser, province_id: value, city: '' });
    } else {
      setEditedUser({ ...editedUser, [name]: value });
    }
  };

  const handleSave = () => {
    // اینجا بعداً به backend ارسال می‌شه
    console.log('اطلاعات بروزشده:', editedUser);
    useAuthStore.getState().login(editedUser, useAuthStore.getState().token);
    setIsEditing(false);
    alert('اطلاعات با موفقیت بروزرسانی شد!');
  };

  const handleCancel = () => {
    setEditedUser({ ...user });
    setIsEditing(false);
  };

  if (!user) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-gold-light to-white flex items-center justify-center">
        <div className="text-center">
          <p className="text-2xl text-gray-700 mb-6">برای مشاهده پروفایل باید وارد شوید</p>
          <a href="/login" className="bg-gold hover:bg-gold-dark text-white px-8 py-4 rounded-xl text-lg font-semibold transition">
            ورود به حساب
          </a>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-gold-light via-white to-gold-light py-12 px-4">
      <div className="container mx-auto max-w-4xl">
        <div className="bg-white rounded-3xl shadow-2xl overflow-hidden">
          {/* هدر پروفایل */}
          <div className="bg-gradient-to-r from-gold to-gold-dark text-white py-12 px-8 text-center">
            <div className="w-32 h-32 mx-auto bg-gold-light rounded-full flex items-center justify-center text-6xl text-gold-dark font-bold shadow-lg">
              {user.first_name?.[0] || 'م'}
            </div>
            <h1 className="text-3xl md:text-4xl font-bold mt-6">
              {user.first_name} {user.last_name}
            </h1>
            <p className="mt-2 text-gold-light text-lg" dir="ltr">{user.phone_number}</p>
          </div>

          <div className="p-8 md:p-12">
            <div className="flex justify-between items-center mb-8">
              <h2 className="text-2xl font-bold text-gray-800">اطلاعات حساب</h2>
              {!isEditing ? (
                <button
                  onClick={() => setIsEditing(true)}
                  className="bg-gold hover:bg-gold-dark text-white px-6 py-3 rounded-lg font-medium transition"
                >
                  ویرایش اطلاعات
                </button>
              ) : (
                <div className="flex gap-4">
                  <button
                    onClick={handleSave}
                    className="bg-green-600 hover:bg-green-700 text-white px-6 py-3 rounded-lg font-medium transition"
                  >
                    ذخیره تغییرات
                  </button>
                  <button
                    onClick={handleCancel}
                    className="bg-gray-500 hover:bg-gray-600 text-white px-6 py-3 rounded-lg font-medium transition"
                  >
                    انصراف
                  </button>
                </div>
              )}
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              {/* ستون چپ - اطلاعات شخصی */}
              <div className="space-y-6">
                <div>
                  <label className="block text-gray-600 text-sm font-medium mb-2">نام</label>
                  {isEditing ? (
                    <input
                      type="text"
                      name="first_name"
                      value={editedUser.first_name || ''}
                      onChange={handleChange}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-gold/50"
                    />
                  ) : (
                    <p className="text-lg text-gray-800">{user.first_name || '-'}</p>
                  )}
                </div>

                <div>
                  <label className="block text-gray-600 text-sm font-medium mb-2">نام خانوادگی</label>
                  {isEditing ? (
                    <input
                      type="text"
                      name="last_name"
                      value={editedUser.last_name || ''}
                      onChange={handleChange}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-gold/50"
                    />
                  ) : (
                    <p className="text-lg text-gray-800">{user.last_name || '-'}</p>
                  )}
                </div>

                <div>
                  <label className="block text-gray-600 text-sm font-medium mb-2">شماره موبایل</label>
                  <p className="text-lg text-gray-800" dir="ltr">{user.phone_number}</p>
                </div>
              </div>

              {/* ستون راست - آدرس */}
              <div className="space-y-6">
                <div>
                  <label className="block text-gray-600 text-sm font-medium mb-2">استان</label>
                  {isEditing ? (
                    <select
                      name="province_id"
                      value={editedUser.province_id || ''}
                      onChange={handleChange}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-gold/50"
                    >
                      <option value="">انتخاب استان</option>
                      {provinces.map(prov => (
                        <option key={prov.id} value={prov.id}>{prov.name}</option>
                      ))}
                    </select>
                  ) : (
                    <p className="text-lg text-gray-800">{user.province || '-'}</p>
                  )}
                </div>

                <div>
                  <label className="block text-gray-600 text-sm font-medium mb-2">شهر</label>
                  {isEditing ? (
                    <select
                      name="city"
                      value={editedUser.city || ''}
                      onChange={handleChange}
                      disabled={!editedUser.province_id}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-gold/50"
                    >
                      <option value="">ابتدا استان را انتخاب کنید</option>
                      {filteredCities.map(city => (
                        <option key={city.id} value={city.name}>{city.name}</option>
                      ))}
                    </select>
                  ) : (
                    <p className="text-lg text-gray-800">{user.city || '-'}</p>
                  )}
                </div>

                <div>
                  <label className="block text-gray-600 text-sm font-medium mb-2">آدرس دقیق</label>
                  {isEditing ? (
                    <textarea
                      name="address"
                      value={editedUser.address || ''}
                      onChange={handleChange}
                      rows="3"
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-gold/50"
                    />
                  ) : (
                    <p className="text-lg text-gray-800">{user.address || '-'}</p>
                  )}
                </div>

                <div>
                  <label className="block text-gray-600 text-sm font-medium mb-2">کد پستی</label>
                  {isEditing ? (
                    <input
                      type="text"
                      name="postal_code"
                      value={editedUser.postal_code || ''}
                      onChange={handleChange}
                      maxLength="10"
                      dir="ltr"
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-gold/50"
                    />
                  ) : (
                    <p className="text-lg text-gray-800" dir="ltr">{user.postal_code || '-'}</p>
                  )}
                </div>
              </div>
            </div>

            {/* دکمه خروج */}
            <div className="mt-12 text-center">
              <button
                onClick={logout}
                className="bg-red-600 hover:bg-red-700 text-white px-10 py-4 rounded-xl font-semibold text-lg transition transform hover:scale-105 shadow-lg"
              >
                خروج از حساب
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;